// extracted by mini-css-extract-plugin
module.exports = {"greenColorFlag":"TableCellColorWrap_greenColorFlag__29Tqx","redColorFlag":"TableCellColorWrap_redColorFlag__2btut","yellowColorFlag":"TableCellColorWrap_yellowColorFlag__1_p9q"};